<template>
  <div class="flex1">
    <audience-create></audience-create>
    <!-- Modal -->
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Audience Delete Error</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{audienceError}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
    </div>
    <div class="row titles">
      <div class="col-md-3 col-12" @click="changeSortParams('name')" >
        {{"Audience Name  " + (sortParams.field === "name" ? (sortParams.direction === "ASC" ? '&#8595;' : '&#8593;' ) : '')}}
      </div>
      <div class="col-md-3 col-12">
        Description
      </div>
      <div class="col-md-2 col-12" @click="changeSortParams('created_at')" >
        {{"Create Date  " + (sortParams.field === "created_at" ? (sortParams.direction === "ASC" ? '&#8595;' : '&#8593;' ) : '')}}
      </div>
      <div class="col-md-2 col-12" @click="changeSortParams('update_time')" >
        {{"Update Date  " + (sortParams.field === "update_time" ? (sortParams.direction === "ASC" ? '&#8595;' : '&#8593;' ) : '')}}
      </div>
      <div class="col-md-2 col-12 center-para" style="text-align: center">
        Actions
      </div>
    </div>
    <div 
      class="row line-hover" 
      v-for="audience in audiences" 
      :key="`audience-${audience.id}`" 
      @click="$router.push({name: 'Audience', params: {id: audience.id}})" 
      >
      <div class="col-md-3 col-12 center-para">
        {{ audience.name }}
      </div>
      <div class="col-md-3 col-12 center-para">
        <input
          v-if="isEditing(audience.id)"
          :id="`edit-audience-${audience.id}`"
          :value="audience.description"
          class="form-control"
          type="text"
          placeholder="Description"
          v-on:click="stopPropagation"
        />
        <span v-else >
          {{ audience.description }}
        </span>
      </div>
      <div class="col-md-2 col-12 center-para">
        {{ dateFormatter(audience.created_at || 0) }}
      </div>
      <div class="col-md-2 col-12 center-para">
        {{ audience.update_time ? dateFormatter(audience.update_time) : "-" }}
      </div>
        <div class="col-md-1 col-12" v-on:click="stopPropagation">
          <button class="btn btn-sm btn-danger" @click="deleteAudience(audience.id)">Delete</button>
        </div>
        <div class="col-md-1 col-12" v-on:click="stopPropagation">
          <button class="btn btn-sm btn-secondary" @click="duplicateAudience(audience.id)">Duplicate</button>
        </div> 
    </div>
  </div>
</template>

<script>
import AudienceCreate from '../components/AudienceCreate'
import formatters from "@/util/formatters";
export default {
  data() {
    return {
      editList: [],
      audienceError: undefined,
      sortParams: {
        field: "created_at",
        direction: "DESC"
      },
      dateFormatter: formatters.dateFormatter,
    }
  },
  computed: {
    audiences() {
      return this.$store.getters.audiences.sort(this.sorter)
    }
  },
  methods: {
    audience(key) {
      const audience = this.audiences.find((item) => item.id == key);
      return audience ? audience : {};
    },
    stopPropagation(event){
      event.stopPropagation();
    },
    duplicateAudience(id){
      const audience = this.audience(id)
      const payload = {
        conditions: audience.conditions,
        created_at: Date.now(),
        description: audience.description,
        name: audience.name +"_duplicate",
        percentage: audience.percentage
      };
      this.$store.dispatch("configAdd", { type: "audience", payload });
    },
    deleteAudience(id){
      if (
        confirm(
          `You are trying to delete "${
            this.audience(id).name
          }" audience. Are you sure?`
        )
      ){
      // check if the audience is being used elsewhere
      const parameters = this.$store.getters.parameters
      const islKeys = this.$store.getters.islKeys
      const experiments = this.$store.getters.experiments
      const parametersWithAudience = []
      const islKeysWithAudience = []
      const experimentsWithAudience = []
      const audiencesWithAudience = []
      parameters.forEach(p => {
        if (p.audience_values && Object.keys(p.audience_values).indexOf(id) >= 0){
          parametersWithAudience.push(p.key)
        }
      })
      islKeys.forEach(i => {
        if (i.audience_values && Object.keys(i.audience_values).indexOf(id) >= 0){
          islKeysWithAudience.push(i.key)
        }
      })
      experiments.forEach(e => {
        if (e.status != 'ended' && e.audience == id){
          experimentsWithAudience.push(e.name)
        }
      })
      this.audiences.forEach(a => {
        const conditions = a.conditions
        for (let i=0; i<conditions.length; i++){
          if (conditions[i].key == "audience") console.log(conditions[i])
          if (conditions[i].key == "audience" && conditions[i].value == id){
            audiencesWithAudience.push(a.name)
            break;
          }
        }
      })
      if (parametersWithAudience.length > 0 ||islKeysWithAudience.length > 0 || experimentsWithAudience.length > 0 || audiencesWithAudience.length > 0){
        const statements = []
        if (parametersWithAudience.length > 0) statements.push(`following parameters: ${parametersWithAudience.map(item => '"'+item+'"').join(', ')}`)
        if (islKeysWithAudience.length > 0) statements.push(`following isl keys: ${islKeysWithAudience.map(item => '"'+item+'"').join(', ')}`)
        if (experimentsWithAudience.length > 0) statements.push(`following experiments: ${ experimentsWithAudience.map(item => '"'+item+'"').join(', ')}`)
        if (audiencesWithAudience.length > 0) statements.push(`following audiences: ${audiencesWithAudience.map(item => '"'+item+'"').join(', ')}`)
        this.audienceError = `You can not delete this audience since it is used in ${statements.join(", and ")}. You have to delete the fields in which this audience is used to be able to delete the audience.`
        $('#exampleModalCenter').modal('show');
      }else{
        this.audienceError = undefined
        this.$store.dispatch('configDelete', {type: 'audience', payload: id})
      }
      }
    },
    activateEdit(id) {
      this.editList.push(id)
    },
    isEditing(id) {
      return this.editList.indexOf(id) >= 0
    },
    changeSortParams(field) {
      if(this.sortParams.field === field) {
        this.sortParams.direction = this.sortParams.direction === "ASC" ? "DESC" : "ASC"
      } else {
        this.sortParams = { field, direction: "ASC"}
      }
    },
    sorter(a, b) {
      const aField = a[this.sortParams.field] || 0;
      const bField = b[this.sortParams.field] || 0;
      if(typeof aField === "string" && typeof bField === "string") {
        if(aField.toUpperCase() < bField.toUpperCase())
          return this.sortParams.direction === "ASC" ? -1 : 1;
        if(aField.toUpperCase() > bField.toUpperCase())
          return this.sortParams.direction === "ASC" ? 1 : -1;
        return 0;
      }
      if(aField < bField)
        return this.sortParams.direction === "ASC" ? -1 : 1;
      if(aField > bField)
        return this.sortParams.direction === "ASC" ? 1 : -1;
      return 0;
    }
  },
  components: {
    AudienceCreate
  }
}
</script>

<style scoped>

</style>